import {createContext} from "react";

const SettingsContext = createContext({
    appSettings: {},
});

export {SettingsContext};
